import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import { ButtonLight } from 'front-end/src/components'

import './Pagination.less'

export interface IPaginationProps {
  totalPages: number
  page: number
  onPageChange: (page: number) => void
}

const ELLIPSIS = <span className="ellipsis">...</span>

const Pagination: FC<IPaginationProps> = (props) => {
  const { page, pages, go, prev, next, ellipsisLeft, ellipsisRight } =
    usePagination(props)

  return (
    <div className="Pagination">
      <div>
        <ButtonLight disabled={!prev} onClick={prev!}>
          <span className="btn-inner">
            <span className="btn-text">
              <Trans>Prev</Trans>
            </span>
          </span>
        </ButtonLight>

        {ellipsisLeft && ELLIPSIS}

        {pages.map((p) => (
          <ButtonLight
            key={p}
            disabled={p === page}
            onClick={() => go(p)}
            className={p === page ? 'active' : ''}
          >
            <span className="btn-inner">
              <span className="btn-text">{p}</span>
            </span>
          </ButtonLight>
        ))}

        {ellipsisRight && ELLIPSIS}

        <ButtonLight disabled={!next} onClick={next!}>
          <span className="btn-inner">
            <span className="btn-text">
              <Trans>Next</Trans>
            </span>
          </span>
        </ButtonLight>
      </div>
    </div>
  )
}

const usePagination = (props: IPaginationProps) => {
  const { page, totalPages, onPageChange: go } = props

  let pages = [...Array(totalPages)].map((_, i) => i + 1)

  if (props.totalPages > 6) {
    const start = Math.max(0, Math.min(totalPages - 6, page - 3))
    pages = pages.slice(start, start + 6)
  }

  return {
    page,
    totalPages,
    ellipsisLeft: page > 3,
    pages,
    ellipsisRight: totalPages - page > 2,
    go,
    prev: page > 1 ? () => go(page - 1) : null,
    next: page < totalPages ? () => go(page + 1) : null
  }
}

export default Pagination
